import {
  answerAwardAmount,
  answerExclusive,
  answerIsCorrectWithHints,
  answerLogicRules,
  answerOther,
  createAnswerSchemaWithMixins,
} from '../answerSchemaFields';
import {
  conditionHasCorrectAnswer,
  createQuestionSchemaWithMixins,
  questionAutoCommit,
  questionAutoNext,
  questionFixedRandomizeAnswers,
  questionHasAnswersLimit,
  questionHasAward,
  questionHasCorrectAnswer,
  questionHasOthers,
  questionHasTimer,
  questionInstantStatistic,
  questionNoneOptionText,
  questionRandomizeAnswers,
  questionRequiresAnswer,
  questionSkipIfOnlySystemAnswers,
} from '../questionSchemaFields';
import { config } from './SelectPoll.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {
    questionAutoCommit,
    questionAutoNext,
    questionHasAward,
    questionHasCorrectAnswer,
    conditionHasCorrectAnswer,
    questionHasOthers,
    questionHasTimer,
    questionHasAnswersLimit,
    questionNoneOptionText,
    questionRandomizeAnswers,
    questionFixedRandomizeAnswers,
    questionRequiresAnswer,
    questionSkipIfOnlySystemAnswers,
    questionInstantStatistic,
  },
  type: config.name,
  answer: createAnswerSchemaWithMixins({
    mixins: {
      answerAwardAmount,
      answerIsCorrectWithHints,
      answerLogicRules,
      answerExclusive,
      answerOther,
    },
  }),
});
